import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import { Map } from 'immutable';

import Question from './Question';
import Section from './Section';

const ObjectId = (rnd = (r16) => Math.floor(r16).toString(16)) =>
  rnd(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => rnd(Math.random() * 16));

const contactDetailsQuestions = [
  {
    notes: '',
    isRequired: false,
    questionType: 'Section',
    title: 'Contact details',
    description:
      'We appreciate your feedback and always look for ways to increase your user satisfaction. Your contact information is requested to collect more reliable data of the feedback provided.',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'First Name',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'Last Name',
  },
  {
    notes: '',
    isRequired: false,
    questionType: 'TextInput',
    title: 'Email',
  },
  {
    notes: '',
    isRequired: false,
    questionType: 'TextInput',
    title: 'Nonprofit name',
  },
];
const addressDetailsQuestions = [
  {
    notes: '',
    isRequired: false,
    questionType: 'Section',
    title: 'Mailing address',
    description: 'Please enter your mailing address.',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'First Name',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'Last Name',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'Address Line 1',
  },
  {
    notes: '',
    isRequired: false,
    questionType: 'TextInput',
    title: 'Address Line 2',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'City',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'State',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'Zip/Postal Code',
  },
  {
    notes: '',
    isRequired: true,
    questionType: 'TextInput',
    title: 'Country',
  },
];

const Questions = ({ fields, meta: { error, submitFailed }, change, isSurvey = false }) => {
  const sections = fields
    .map((question, index) => fields.get(index))
    .filter((item) => item.get('questionType') === 'Section');
  let currentSection = 0;
  return (
    <div>
      {fields.length === 0 ? (
        <div>
          <Button
            onClick={() => {
              contactDetailsQuestions.forEach((q) =>
                fields.push(new Map({ ...q, _id: ObjectId() }))
              );
            }}
            size="small"
          >
            <AddIcon />
            Add contact details section
          </Button>
          <Button
            onClick={() => {
              addressDetailsQuestions.forEach((q) =>
                fields.push(new Map({ ...q, _id: ObjectId() }))
              );
            }}
            size="small"
            style={{ marginLeft: '5px' }}
          >
            <AddIcon />
            Add mailing address section
          </Button>
        </div>
      ) : null}
      {submitFailed && error && <span>{error}</span>}
      {fields.map((question, index) => {
        const remove = () => fields.remove(index);
        const item = fields.get(index);
        const { move } = fields;
        if (item.get('questionType') === 'Section') {
          currentSection += 1;
        }
        return item.get('questionType') === 'Section' ? (
          <Section
            question={question}
            key={item.get('_id') || index}
            questionId={item.get('_id')}
            questionType={item.get('questionType')}
            remove={remove}
            move={move}
            index={index}
            sections={sections}
            currentSection={currentSection}
            isSurvey={isSurvey}
          />
        ) : (
          <Question
            question={question}
            key={item.get('_id') || index}
            questionId={item.get('_id')}
            questionType={item.get('questionType')}
            item={item}
            change={change}
            remove={remove}
            move={move}
            index={index}
            sections={sections}
            isSurvey={isSurvey}
          />
        );
      })}
      <Button
        variant="outlined"
        onClick={() =>
          fields.push(
            new Map({
              _id: ObjectId(),
              questionType: 'TextInput',
              title: '',
              isRequired: true,
            })
          )
        }
        size="small"
        style={{ marginTop: 20, paddingRight: 15 }}
      >
        <AddIcon />
        Add question
      </Button>{' '}
      <Button
        variant="outlined"
        onClick={() =>
          fields.push(
            new Map({
              _id: ObjectId(),
              questionType: 'Section',
              title: '',
              isRequired: false,
            })
          )
        }
        size="small"
        style={{ marginTop: 20, paddingRight: 15 }}
      >
        <AddIcon />
        Add section
      </Button>
    </div>
  );
};
Questions.propTypes = {
  fields: PropTypes.object,
  meta: PropTypes.object,
  change: PropTypes.func,
  isSurvey: PropTypes.bool,
};
export default Questions;
